
<div class="container">
  <div class="row">
    <div class="col page-title-container">
      <h2 class="hidden-xs-down">Site</h2>
      <ol class="breadcrumb">
        <li class="breadcrumb-item"><a [routerLink]="['/projects']">Projects</a></li>
        <li class="breadcrumb-item" *ngIf="site?.projectId &amp;&amp; site?.projectName"><a [routerLink]="['/project']" [queryParams]="{id: site?.projectId}">{{ site?.projectName }}</a></li>
        <li class="breadcrumb-item"><a [routerLink]="['/sites']" [queryParams]="{projectId: site?.projectId}">Sites</a></li>
        <li class="breadcrumb-item active" *ngIf="site?.name">{{ site?.name }}</li>
      </ol>
      <error [error]="error"></error>
    </div>
  </div>
  <div class="row">
    <div class="col">
      <div class="card-item" *ngIf="site">
        <div class="card-progress-bar float-right">
          <div class="progress">
            <div class="progress-bar" role="progressbar" title="{{ site.deployedPercentageBar.title }}" [ngClass]="site.deployedPercentageBar.type" [style.width]="site.deployedPercentageBar.width + '%'">{{site.deployedPercentageBar.value + "%"}}</div>
          </div>
        </div>
        <h4>{{ site.name }}</h4>
        <property-container>
          <property-item><a [href]="'/#/workflow/' + site.workflowId">Set Up Site</a></property-item>
        </property-container>
        <property-container *appSetting="'buildingsAndFloors'">
          <property-item *appSetting="'displayUnsupportedSimplifyFeatures'"><a [routerLink]="['/building']" [queryParams]="{siteId: site?.id}">Buildings</a></property-item>
        </property-container>
        <property-container>
          <property-item><a [href]="'/#/orders?siteId=' + site.id">{{ site.orderCount || 0 }} order(s)</a></property-item>
          <property-item><a [href]="'/#/deployments?projectId=' + site?.projectId + '&amp;siteId=' + site.id">{{ site.deploymentCount || 0 }} deployment(s)</a></property-item>
        </property-container>
        <property-container *appSetting="'displayUnsupportedSimplifyFeatures'">
          <property-item><a [href]="'/#/device-defects?siteId=' + site.id">Defective Asset Replacements</a></property-item>
          <property-item><a [href]="'/#/device-relocations?siteId=' + site.id">Reused & Relocated Assets</a></property-item>
        </property-container>
        <property-container>
          <property-item [showIf]="site.k2Name">K2/ACDC Site Name: {{ site.k2Name }}</property-item>
          <property-item [showIf]="site.siteCode">Site Code: {{ site.siteCode }}</property-item>
        </property-container>
        <property-container>
          <property-item [showIf]="site.estimatedStartDate">Start Date: {{ site.estimatedStartDate | date: 'yyyy-MM-dd' : 'UTC'}}</property-item>
          <property-item [showIf]="site.estimatedCompleteDate">End Date: {{ site.estimatedCompleteDate | date: 'yyyy-MM-dd': 'UTC'}}</property-item>
        </property-container>
        <property-container>
          <property-item [showIf]="site.hardwareOrderDate">Estimated Hardware Order Date: {{ site.hardwareOrderDate | date: 'yyyy-MM-dd': 'UTC'}}</property-item>
          <property-item [showIf]="site.deliveryDate">Estimated Delivery Date: {{ site.deliveryDate | date: 'yyyy-MM-dd': 'UTC'}}</property-item>
          <property-item [showIf]="site.installDate">Estimated Installation Date: {{ site.installDate | date: 'yyyy-MM-dd': 'UTC'}}</property-item>
        </property-container>
        <property-container>
          <property-item [showIf]="site.approvedDate">Approved Date: {{ site.approvedDate | date: 'yyyy-MM-dd': 'UTC'}}</property-item>
          <property-item [showIf]="site.submissionDate">Estimated Submission Date: {{ site.submissionDate | date: 'yyyy-MM-dd': 'UTC' }}</property-item>
          <property-item [showIf]="site.completionDate">Estimated Completion Date: {{ site.completionDate | date: 'yyyy-MM-dd': 'UTC' }}</property-item>
        </property-container>
        <property-container>
          <property-item>{{ site.plannedDevices }} device(s) planned</property-item>
          <property-item>{{ site.deployedDevices }} device(s) deployed</property-item>
        </property-container>
        <property-container class="red">
          <property-item [showIf]="site.pastSchedule"><span class="oi oi-clock"></span> {{ site.pastScheduleMessage }}</property-item>
        </property-container>
        <hr>
        <h5>Contacts:</h5>
        <div class="row ml-4 mr-4 mt-3">
          <table class="table table-sm">
            <thead>
              <tr>
                <th>Type</th>
                <th>Name</th>
                <th>Phone Number</th>
                <th>Email Address</th>
              </tr>
            </thead>
            <tbody>
              <ng-container *ngFor="let c of contactTypes">
                <tr *ngIf="site[c.field]">
                  <td>{{ c.name}}</td>
                  <td>{{ site[c.field].firstName }} {{ site[c.field].lastName }}</td>
                  <td>{{ site[c.field].phoneNumber }}</td>
                  <td><a [href]="'mailto:' + site[c.field].emailAddress">{{ site[c.field].emailAddress }}</a></td>
                  <td>
                    <div class="links"><a href="javascript:void(0)" (click)="editSiteContact(c.field, site[c.identifier])"><span class="oi oi-pencil oi-smaller"></span> Edit</a></div>
                  </td>
                </tr>
              </ng-container>
              <tr *ngIf="!hasContacts">
                <td colspan="4">
                  <p class="text-center empty-table-message">There are no contacts to display.</p>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="row">
          <div class="col mb-2 ml-4">
            <div class="btn-group mr-2">
              <button class="btn btn-outline-primary" type="button" [downloadFile]="'/api/sites/export-contacts'" [params]="{siteId: site.id}"><span class="oi oi-cloud-download"></span> Export Contacts</button>
            </div>
            <div class="btn-group"><a class="btn btn-outline-primary" [uploadFileTo]="'/api/sites/import-contacts?siteId=' + site.id" [fileExtensions]="['xls', 'xlsx', 'xlsm', 'xlsb']" (closed)="importContactsClosed($event)"><span class="oi oi-cloud-upload"></span> Import Contacts</a></div>
          </div>
        </div>
        <div class="clearfix"></div>
        <div class="float-right">
          <div class="btn-group" *ngIf="site.requestedOrdersCount &lt;= 0 &amp;&amp; site.orderedDevices &lt;= 0 &amp;&amp; site.deployedDevices &lt;= 0">
            <button class="btn btn-outline-danger" type="button" (click)="remove()"><span class="oi oi-trash"></span> Remove</button>
          </div>
        </div>
        <div class="clearfix"></div>
      </div>
    </div>
  </div>
</div>